export default __webpack_public_path__ + "static/icon-tile-light-74e1a14ac69328ca18b44a0513730872b8225b0b4f247d961c6fa0c8eff9a626.png";